export default "__VITE_ASSET__DrhqCqqo__"